import { render, staticRenderFns } from "./EditorAutoPayments.vue?vue&type=template&id=451fd522&scoped=true&"
import script from "./EditorAutoPayments.vue?vue&type=script&lang=js&"
export * from "./EditorAutoPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451fd522",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('451fd522')) {
      api.createRecord('451fd522', component.options)
    } else {
      api.reload('451fd522', component.options)
    }
    module.hot.accept("./EditorAutoPayments.vue?vue&type=template&id=451fd522&scoped=true&", function () {
      api.rerender('451fd522', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/editors/EditorAutoPayments.vue"
export default component.exports